import { saveAs } from "file-saver"
import React, { useState } from "react"
import { Button, Dropdown, DropdownButton } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { AllInfoPdfGenerate, fetchAPIData, isLoggedIn } from "../../api/AuthService"
import { DOWNLOAD_LINK, PDF_DOWNLOAD_LINK } from "../../constant/Constants"
import { PDFViews } from "../../constant/PDFoptions"
import { expandCollapseAll } from "../commonComponents/EventHandler"

const PdfDownloadComponent = ({ pdfDataSet, genDocHide, pdfHide }) => {
   const [loading, setLoading] = useState(false)
   const [genDocLoading, setGedDocLoading] = useState(false)

   const gendochide = genDocHide ? genDocHide : false
   const pdfhide = pdfHide ? pdfHide : false
   const pathParts = window.location.pathname.split("/")
   const isPreliminary = pathParts[1] === "preliminary"
   // On /preliminary/:type/:searchId/:partName  — type is [2], searchId is [3]
   // On /:type/:objectID                         — type is [1], objectID is [2]
   // Decode segments because window.location.pathname returns percent-encoded values
   //  while useParams() in AllInfo components returns decoded values.
   const decode = (s) => { try { return s ? decodeURIComponent(s) : s } catch(e) { return s } }
   const type = isPreliminary ? decode(pathParts[2]) : decode(pathParts[1])
   var object_ID = window.location.pathname.split("/")[2]
   // For PDF download: on preliminary route the searchId is at position [3], otherwise [2]
   var pdfObjectID = isPreliminary ? decode(pathParts[3]) : decode(object_ID) || null
   // const options = PDFViews[type]?PDFViews[type]:""
   const role = localStorage.getItem("role")
   const CPView = {CM: 'Consolidated Packing View'}
   const options = (type == 'FPP' && role == "") ? CPView : (PDFViews[type] ? PDFViews[type] : "")
   const navigate = useNavigate()
   //Download Allinfo pdf
   const downloadPdfFile = (view) => {
      if (!isLoggedIn()) {
         navigate("/")
      } else {
         let fileName = "download"
         fileName = pdfDataSet["Name"] ? ( pdfDataSet["Rev"] ? pdfDataSet["Name"]+"-Rev"+pdfDataSet["Rev"] : pdfDataSet["Name"] ) : fileName
         if(view && view ==="All"){
            setLoading(true)
         }
         AllInfoPdfGenerate(`${PDF_DOWNLOAD_LINK}`, type, pdfDataSet, pdfObjectID, isPreliminary ? (view && view !== "All" ? `preliminary ${view}` : "preliminary") : view)
            .then((response) => {
               if(response.status === 202){
                  alert("As the Consolidated Packaging View PDF is huge, the PDF will be emailed to you in some time.")
               }
               else{
                  const blob = new Blob([response.data], {
                  type: "application/pdf",
               })

               let fileContents = URL.createObjectURL(blob)
               saveAs(fileContents, fileName)
               }
               
               setLoading(false)
            })
            .catch((error) => {
               if (error.response && error.response.status === 422) {
                  //setShow(true)
                  alert(
                     "You have exceeded the limit for the day and access to any additional Part/Specification is blocked! Please wait until the limit resets tomorrow or contact SpecReaderExt.im@pg.com and request the limit be reset."
                  )
               } 
               else if(error.response && error.response.data.status === 401){
                  navigate("/")
               }
               else {
                  alert("Integration service issue. Please contact SpecReaderExt.im@pg.com for help.")
                  console.log(" error", error)
               }
               setLoading(false)
            })
      }
   }

   //Download GenDoc File
   const downloadGenDocFile = () => {
      if (!isLoggedIn()) {
         navigate("/")
      } else {
         var fileName = "download"
         setGedDocLoading(true)

         fetchAPIData(`${DOWNLOAD_LINK}${object_ID}`, { responseType: "blob" })
            .then(function (response) {
               if (
                  response.headers["filename"] != null &&
                  response.headers["filename"] !== ""
               ) {
                  fileName = response.headers["filename"]
               }
               const fileContents = new Blob([response.data])
               saveAs(fileContents, fileName)
               setGedDocLoading(false)
            })
            .catch((error) => {
               if (error.response && error.response.status === 404) {
                  alert("No file is avilable to download.Please contact SpecReaderExt.im@pg.com for help.")
               } else if (error.response && error.response.status === 422) {
                  alert(
                     "You have exceeded the limit for the day and access to any additional Part/Specification is blocked! Please wait until the limit resets tomorrow or contact SpecReaderExt.im@pg.com and request the limit be reset."
                  )
               } 
               else if(error.response && error.response.data.status === 401){
                  navigate("/")
               }
               else {
                  alert("Integration service issue. Please contact SpecReaderExt.im@pg.com for help.")
                  console.log("FCS Error Response:-", error)
               }
               setGedDocLoading(false)
            })
      }
   }

   const RenderOptins = (props) => {
      let keys =  Object.keys(props.data)
      
      return keys.map((key, index) => {
         return  <Dropdown.Item onClick={()=> downloadPdfFile(key)}>{props.data[key]}</Dropdown.Item>
      })
   }

   return (
      <React.Fragment>
         <div>
            {!gendochide && (
               <Button
                  style={{ textAlign: "center",marginRight:"0.1rem" }}
                  className="expandCollapseButton"
                  onClick={downloadGenDocFile}
               >
                  {genDocLoading ? (
                     <i className="fa fa-spinner fa-spin" style={{ marginRight: "5px" }} />
                  ) : (
                     <span>GenDoc &#8595;</span>
                  )}
               </Button>
            )}
            &nbsp;
            {!pdfhide && (
                  <Button
                     style={{ textAlign: "center" }}
                     className="expandCollapseButton"
                     onClick={()=>downloadPdfFile("All")}
                  >
                     {loading ? (
                        <i className="fa fa-spinner fa-spin" style={{ marginRight: "5px" }} />
                     ) : (
                        <span>PDF &#8595;</span>
                     )}
                  </Button>
               )
            }
            &nbsp;
            <Button
               id="btnExpandAll"
               className="expandCollapseButton"
               onClick={expandCollapseAll}
            >
               Collapse All
            </Button>
         </div>
         <React.Fragment>
            {role === "" &&
               options !== "" && (
                  <DropdownButton style={{align:"right",marginTop:"3px"}} id="options" title="Other Views">
                     <RenderOptins data={options} />
                  </DropdownButton>
               )
            }
         </React.Fragment>
      </React.Fragment>
   )
}
export default PdfDownloadComponent